import {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from "react";
import { IssueAppType, TotalNxacType } from "src/service/types/pay.type";
import { userInfoAtom } from "src/atoms";
import { useRecoilState } from "recoil";
import { useGetTotalNxacList } from "src/hooks/api/nxac/useGetTotalNxacList";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import { useRouter } from "src/hooks/useRouter";
import { notifyError, notifySuccess } from "src/components/Common/Toast";
import { useModal } from "src/hooks/useModal";
import RightDetailBox from "./_RightDetailBox";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { createServicePromotionAskV2 } from "src/service/pay";
import CheckboxWithLabel from "../Common/Form/ReactHookForm/CheckboxWithLabel";
import { ModalsStateContext } from "src/context/Modal/Console/ConsoleModal.context";
import { ModalsDispatchContext } from "src/context/Modal/Console/ConsoleModal.context";
import * as yup from "yup";
import dayjs from "dayjs";
import { yupResolver } from "@hookform/resolvers/yup";
import DateInput from "../Common/Form/ReactHookForm/DateInput";
import InputField from "../Common/Form/ReactHookForm/InputField";
import { formatPhoneNumber } from "src/utils/common";
import { useTranslation } from "react-i18next";

interface IApplyPromotionProps {
  startDate: string;
  setStartDate: Dispatch<SetStateAction<string>>;
  endDate: string;
  setEndDate: Dispatch<SetStateAction<string>>;
  toggleAskPromotionOn: boolean;
  setToggleAskPromotionOn: Dispatch<SetStateAction<boolean>>;
}
const schema = yup.object({
  companyName: yup.string().required("admin.common.alert.check.enterCompany"),
  startDate: yup.string().notRequired(),
  endDate: yup.string().notRequired(),
  // externalLicenseCount: yup.number().required(),
  // licenseCount: yup.number().min(10).required(),
  licenseCount: yup.number().required(),
  externalLicenseCount: yup.number(), // Wrapsody, Wrapsody eCo 에 따라 조율할 것
  product: yup.string().required(),
  purpose: yup.string().notRequired(),
  telNumber: yup.string().required("siteType.free.detail.alertMsg5"), // .matches(/^[0-9]{2,3}-[0-9]{3,4}-[0-9]{4}$/, ""),
  userPerStorage: yup
    .number()
    .min(1)
    .max(99999999)
    .required("siteType.premium.detail.plan.userStorageCheckMsg"),
  userName: yup
    .string()
    .required("logIn.enterName") // 이름을 입력해주세요
    .max(50, "siteType.free.detail.alertMsg1"), // 50자까지 입력할 수 있습니다
  // userPerStorage: yup.number().min(0).required(),
  issueAppList: yup
    .array()
    .of(
      yup.object({
        id: yup.string().required(),
        name: yup.string().required(),
      })
    )
    .notRequired(),
  // ✅ 여기 추가
  confirmPolicy: yup
    .boolean()
    .oneOf([true], "logIn.signUp.agreement") // 이용약관 및 개인정보처리방침에 동의해주세요.
    .required(),
  // .oneOf([true], t("siteType.info"))
});
const AskPromotion = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  toggleAskPromotionOn,
  // setIsCheckAskPromotion,
  setToggleAskPromotionOn,
}: // isCheckAskPromotion,
IApplyPromotionProps) => {
  const [userInfo, setUserInfo] = useRecoilState(userInfoAtom);
  const { userName, companyName } = userInfo;
  const [userPerStorage, setUserPerStorage] = useState(100);
  // const [externalLicenseCount, setExternalLicenseCount] = useState(10);
  const [confirmPolicy, setConfirmPolicy] = useState(false);
  const { t } = useTranslation();
  // const [selectAppList, setSelectAppList] = useState<string[]>([]);
  const [isApplyDone, setIsApplyDone] = useState(false);
  const route = useRouter();
  const { openTermsService, openPrivatePolicy, openPaidTermsService } =
    useModal();
  type FormValues = yup.InferType<typeof schema>;
  const methods = useForm<FormValues>({
    defaultValues: {
      userName,
      companyName,
      product: getProductFromSessionStorage(),
      licenseCount: 10,
      externalLicenseCount: 10,
      userPerStorage: 5,
      startDate: dayjs().format("YYYY-MM-DD"), // "2024-01-01", // ISO 8601 형식 문자열
      endDate: dayjs().add(1, "year").format("YYYY-MM-DD"), // "2024-01-31",
    },
    resolver: yupResolver(schema),
    mode: "onChange",
    criteriaMode: "all", // 모든 유효성 검사 규칙을 확인
  });
  const {
    register,
    handleSubmit,
    control,
    watch,
    getValues,
    setValue,
    formState: { isValid, errors },
  } = methods;
  // const handleChange = (
  //   e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  // ) => {
  //   if (e.target.name === "confirmPolicy") {
  //     setConfirmPolicy((prev) => {
  //       // console.log("confirmPolicy", !prev);
  //       return !prev;
  //     });
  //   } else if (e.target.name === "licenseCount") {
  //     // state[e.target.name].length > 4
  //     //   ? (state[e.target.name] = e.target.value.substr(0, 4))
  //     //   : (state[e.target.name] = e.target.value)
  //     if (parseInt(e.target.value) > 9999) {
  //       return;
  //     }
  //     setLicenseCount(parseInt(e.target.value));
  //   } else if (e.target.name === "userPerStorage") {
  //     // state[e.target.name].length > 8
  //     //   ? (state[e.target.name] = e.target.value.substr(0, 8))
  //     //   : (state[e.target.name] = e.target.value)
  //     if (parseInt(e.target.value) > 99999999) {
  //       return;
  //     }
  //     setUserPerStorage(parseInt(e.target.value));
  //   } else if (e.target.name === "externalLicenseCount") {
  //     // state[e.target.name].length > 4
  //     //   ? (state[e.target.name] = e.target.value.substr(0, 4))
  //     //   : (state[e.target.name] = e.target.value)
  //     if (parseInt(e.target.value) > 9999) {
  //       return;
  //     }
  //     setExternalLicenseCount(parseInt(e.target.value));
  //   } else if (e.target.name === "selectAppList") {
  //     // console.log("selectAppList", e.target.value);
  //     if (selectAppList.indexOf(e.target.value as never) !== -1) {
  //       setSelectAppList((prev) => prev.filter((el) => el !== e.target.value));
  //     } else {
  //       setSelectAppList((prev) => prev.concat(e.target.value as never));
  //     }
  //   } else if (e.target.name === "telNumber") {
  //     setTelNumber(e.target.value);
  //   } else if (e.target.name === "purpose") {
  //     setPurpose(e.target.value);
  //   }
  // };
  // const handleChangeForDate = (date: string, target: string) => {
  //   if (target === "startDate") {
  //     // console.log(state['endDate'])
  //     if (moment(date).format("YYYY-MM-DD") > endDate) {
  //       setStartDate(moment(date).format("YYYY-MM-DD"));
  //       setValue("startDate", moment(date).format("YYYY-MM-DD"));
  //       // state[target] = moment(state['endDate']).format('YYYY-MM-DD')
  //     } else {
  //       setStartDate(moment(date).format("YYYY-MM-DD"));
  //       setValue("startDate", moment(date).format("YYYY-MM-DD"));
  //     }
  //   } else if (target === "endDate") {
  //     setEndDate(moment(date).format("YYYY-MM-DD"));
  //     setValue("endDate", moment(date).format("YYYY-MM-DD"));
  //   }
  // };

  // useEffect(() => {}, [selectAppList]);
  // 원래는 요청하는 API값에 맞게 세팅했음
  // const onSubmit: SubmitHandler<ICreateServicePromotionAskV2Req> = async (
  const onSubmit: SubmitHandler<FormValues> = async (result) => {
    const {
      userName,
      telNumber,
      companyName,
      purpose,
      licenseCount,
      userPerStorage,
      startDate,
      endDate,
      externalLicenseCount,
      issueAppList,
      // referralId,
    } = result;
    // console.log("result", result);
    // 이전에 사용하던 조건들...
    // if (!isCheckAskPromotion) {
    //   alert(t("common.alert.enterRequired"));
    //   return;
    // }
    // const userNameLength = maxLengthValidation(userInfo.userName, 50);
    // const telNumberLength = maxLengthValidation(telNumber, 30);
    // const companyNameLength = maxLengthValidation(companyName, 100);
    // const purposeLength = maxLengthValidation(purpose, 500);

    // if (
    //   !userNameLength ||
    //   !telNumberLength ||
    //   !companyNameLength ||
    //   !purposeLength
    // ) {
    //   if (!userNameLength) {
    //     setUsernameNoti(t("siteType.free.detail.alertMsg1"));
    //   } else {
    //     setUsernameNoti("");
    //   }

    //   if (!telNumberLength) {
    //     setContactInfoNoti(
    //       t("siteType.free.detail.alertMsg2")
    //     );
    //   } else {
    //     setContactInfoNoti("");
    //   }

    //   if (!companyNameLength) {
    //     setCompanyNoti(t("siteType.free.detail.alertMsg3"));
    //   } else {
    //     setCompanyNoti("");
    //   }

    //   if (!purposeLength) {
    //     setPurposeNoti(t("siteType.free.detail.alertMsg4"));
    //   } else {
    //     setPurposeNoti("");
    //   }

    //   return;
    // }

    // console.log("result", result);
    // console.log("nxacList", nxacList);
    // console.log("issueAppList", issueAppList);
    // let filterResult: any;
    // if (nxacList !== undefined && issueAppList !== undefined) {
    //   const tempNxacList: TotalNxacType[] = [...nxacList];
    //   const filterNxacList = tempNxacList.filter((data: any) =>
    //     issueAppList?.includes(data.nxacAppUid)
    //   );
    //   if (filterNxacList) {
    //     filterResult = filterNxacList?.map((data) => {
    //       const { applicationName, nxacAppUid } = data;
    //       return {
    //         id: nxacAppUid,
    //         name: applicationName,
    //       };
    //     });
    //     // console.log("filterResult", filterResult);
    //   }
    // }
    // console.log("filterResult", filterResult);
    await createServicePromotionAskV2({
      userName,
      telNumber,
      companyName,
      purpose,
      licenseCount,
      userPerStorage,
      startDate,
      endDate,
      externalLicenseCount,
      // nxacAppUids: selectAppList,
      issueAppList: issueAppList || [],
      product: getProductFromSessionStorage(),
      // referralId,
    })
      .then((result) => {
        setIsApplyDone(true);
        notifySuccess(t("siteType.promotionApply.title"));
        setToggleAskPromotionOn((prev) => !prev);
        route.goSitePromotion({});
      })
      .catch((error: any) => {
        if (error?.errorCode && error?.errorMessage) {
          notifyError(error.errorMessage);
        }
      });
  };

  return (
    <form className="form" onSubmit={handleSubmit(onSubmit)}>
      <div className="flex justify-space-between">
        <div className="flex-item box box__lt bg-white">
          <h4 className="form-title">
            {
              t("siteType.free.detail.title") // 사용자 정보
            }
          </h4>
          {/* 담당자 이름 + 프로모션 코드가 있으신가요? */}
          <InputField
            register={register}
            name="userName"
            label={t("siteType.free.detail.username")}
            labelRight={
              // 프리미엄 코드가 있으신가요?
              <span
                className="form-item-question cursor-pointer"
                onClick={() => setToggleAskPromotionOn((prev) => !prev)}
              >
                {
                  t("siteType.premium.detail.plan.haveCode") // 프리미엄 코드가 있으신가요?
                }
              </span>
            }
            required={true}
            errors={errors}
          />
          <InputField
            register={register}
            name="telNumber"
            label={t("siteType.free.detail.phoneNumber")}
            onChange={(e) => {
              e.target.value = formatPhoneNumber(e.target.value);
            }}
            required={true}
            errors={errors}
          />
          <InputField
            register={register}
            name="companyName"
            label={t("siteType.free.detail.company")}
            required={true}
            errors={errors}
          />
          {/* 사용목적 */}
          <InputField
            register={register}
            name="purpose"
            label={t("siteType.free.detail.purpose")}
            errors={errors}
            type="textarea"
          />

          <h4 className="form-title">
            {t("siteType.premium.detail.plan.title")}
          </h4>

          <div className="form-item">
            <span className="form-item-title">
              {t("siteType.basic.detail.plan.userNum")}
            </span>
            <input
              {...register("licenseCount")}
              type="number"
              className="form-control custom-form width max-w-110"
              min={10}
              max={9999}
            />
          </div>
          {/* 구독 희망 기간 */}
          <div className="form-item">
            <span className="form-item-title">
              {t("siteType.premium.detail.plan.period")}
            </span>
            <div className="flex align-bottom input_date">
              <DateInput
                control={control}
                name="startDate"
                label={t("siteType.premium.detail.plan.startDate")}
              />
              <DateInput
                control={control}
                name="endDate"
                label={t("siteType.premium.detail.plan.endDate")}
              />
            </div>
          </div>

          <div className="form-item">
            <span className="form-item-title">
              {t("siteType.premium.detail.plan.userStorage")}
            </span>

            <input
              {...register("userPerStorage")}
              type="number"
              className="form-control custom-form width max-w-110"
              min={1}
              max={99999999}
            />
          </div>

          {userPerStorage < 1 || userPerStorage > 99999999 ? (
            <div className="mg mt--10 mb-20">
              <span className="form-invalid">
                {t("siteType.premium.detail.plan.userStorageCheckMsg", {
                  0: 1,
                  1: 99999999,
                })}
              </span>
            </div>
          ) : (
            ""
          )}
          {/* 외부 사용자 */}
          {getProductFromSessionStorage() === "WRAPSODY_ECO" && (
            <div className="form-item">
              <span className="form-item-title">
                {t("siteType.premium.detail.plan.userExtenalInvite")}
              </span>
              <input
                {...register("externalLicenseCount")}
                type="number"
                // defaultValue={externalLicenseCount}
                className="form-control custom-form width max-w-110"
                min={10}
                max={9999}
              />
            </div>
          )}

          {/* {externalLicenseCount < 10 || externalLicenseCount > 9999 ? (
            <div className="mg mt--10 mb-20">
              <span className="form-invalid">
                {t(
                  "siteType.premium.detail.plan.userExtenalInviteCheckMsg",
                  10,
                  9999
                )}
              </span>
            </div>
          ) : (
            ""
          )} */}
          {/* 이용약관 동의 */}
          <CheckboxWithLabel
            id="confirmPolicy"
            name="confirmPolicy"
            register={register}
            errors={errors}
            // infoText={t("siteType.info")}
            labelContent={
              <>
                {t("siteType.agreement1")}
                <a onClick={openTermsService} className="cursor-pointer">
                  <b className="text text--black">{t("siteType.agreement2")}</b>
                </a>
                {t("siteType.agreement3")}
                <a onClick={openPrivatePolicy} className="cursor-pointer">
                  <b className="text text--black">{t("siteType.agreement4")}</b>
                </a>
                {/* 유료 이용약관 전부 제거 */}
                {/* {window.sessionStorage.getItem("product") ===
                  "WRAPSODY_ECO" && (
                  <>
                    {t("siteType.agreement5")}
                    <a
                      onClick={openPaidTermsService}
                      className="cursor-pointer"
                    >
                      <b className="text text--black">
                        {t("siteType.agreement6")}
                      </b>
                    </a>
                  </>
                )} */}
                {t("siteType.agreement7")}
              </>
            }
          />
        </div>

        <RightDetailBox
          licenseCount={watch("licenseCount") || 0}
          externalLicenseCount={watch("externalLicenseCount") || 0}
          toggleAskPromotionOn={toggleAskPromotionOn}
          startDate={startDate}
          endDate={endDate}
          setValue={setValue}
          // selectAppList={selectAppList}
          // setSelectAppList={setSelectAppList}
          isCheckAskPromotion={isValid}
        />
      </div>
    </form>
  );
};

export default AskPromotion;
